var _templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: 0 0.4rem 0.5rem 0.0625rem #dbdbdc;\n  z-index: 2;\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: 0 0.4rem 0.5rem 0.0625rem #dbdbdc;\n  z-index: 2;\n"]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

import ListItem from "../ListItem";

var Wrapper = styled.div(_templateObject);

var List = function List(_ref) {
  var customRender = _ref.customRender,
      items = _ref.items,
      activeItemIndex = _ref.activeItemIndex,
      onSelect = _ref.onSelect,
      textNoResults = _ref.textNoResults;

  if (items.length > 0) {
    return React.createElement(
      Wrapper,
      null,
      items.map(function (item, index) {
        return React.createElement(ListItem, {
          key: index,
          active: activeItemIndex === index,
          customRender: customRender,
          onClick: function onClick(item) {
            return onSelect(item);
          },
          item: item
        });
      })
    );
  }

  if (textNoResults || customRender) {
    return React.createElement(
      Wrapper,
      null,
      React.createElement(ListItem, { customRender: customRender, textNoResults: textNoResults })
    );
  }

  return null;
};

List.propTypes = process.env.NODE_ENV !== "production" ? {
  activeItemIndex: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    matched_substrings: PropTypes.arrayOf(PropTypes.shape({
      length: PropTypes.number.isRequired,
      offset: PropTypes.number.isRequired
    }))
  })),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.instanceOf(ListItem)), PropTypes.instanceOf(ListItem)]),
  onSelect: PropTypes.func,
  customRender: PropTypes.func,
  textNoResults: PropTypes.string
} : {};

List.defaultProps = {
  items: []
};

export default List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-places-suggest/es/components/List/index.js
// module id = 795
// module chunks = 0